// extracted by mini-css-extract-plugin
module.exports = {"code-highlight":"prism_code-highlight__kjMpU","language-csharp":"prism_language-csharp__MSyN_","language-java":"prism_language-java__hLJAn"};